import { NibbleType } from '@aipb/personal-content/shared/model';
import { CommonModule } from '@angular/common';

import { Component, computed, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'pc-nibble-type-icon',
  template: `
    <mat-icon [ngStyle]="styles()" [title]="title() | transloco">
      {{ icon() }}
    </mat-icon>
  `,
  imports: [CommonModule, MatIconModule, TranslocoModule]
})
export class NibbleTypeIconComponent {
  type = input<NibbleType | 'COLL_CUSTOM'>('REC');
  disabled = input(false);

  icon = computed(() => {
    const type = this.type();

    switch (type) {
      case 'REC':
        return 'description';
      case 'RECDBOX':
        return 'deployed_code';
      case 'TXT':
        return 'text_fields';
      case 'SRCH':
        return 'feature_search';
      case 'COLL':
        return 'layers';
      case 'COLL_CUSTOM':
        return 'layers';
      case 'DOC':
      case 'DOC3IF':
        return 'book';
      case 'PAGE':
        return 'import_contacts';
      case 'IMG':
        return 'image';
      case 'IMG3F':
        return 'import_contacts';
      case 'CROP':
        return 'crop';
      case 'VID':
        return 'videocam';
      case 'AUD':
        return 'volume_up';
      case 'LINK':
        return 'link';
    }

    return 'description';
  });

  title = computed(() => {
    const type = this.type();

    return 'personal_content.nibble_types.' + type;
  });

  // @ts-expect-error foo
  styles = computed<Record<string, string>>(() => {
    const disabled = this.disabled();
    const type = this.type();

    if (disabled) {
      return {
        color: '#aaaaaa'
      };
    }

    switch (type) {
      case 'RECDBOX':
        return {
          color: '#52a3f3'
        };
      case 'COLL':
        return {
          color: '#2B547E'
        };
    }

    return {};
  });
}
